import { SignInPage } from '@backstage/core-components';
import { githubAuthApiRef } from '@backstage/core-plugin-api';
import { createApp } from '@backstage/frontend-defaults';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import {
  deliveryCatalogPlugin,
  catalogDeliveryModule,
} from './modules/catalog/catalogModule';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import signalsPlugin from '@backstage/plugin-signals/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import { releasesPlugin } from './modules/releases';
import { organizationSettingsPlugin } from './modules/settings';
import { spatialwalkThemeModule } from './modules/theme';
import { platformControlPlugin } from './modules/platform';
import { scaffolderFieldsModule } from './modules/scaffolder';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      (
        <SignInPage
          {...props}
          provider={{
            id: 'github-auth-provider',
            title: 'GitHub',
            message: 'Sign in using GitHub',
            apiRef: githubAuthApiRef,
          }}
        />
      ),
  },
});

const signInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
});

export default createApp({
  features: [
    deliveryCatalogPlugin,
    catalogDeliveryModule,
    notificationsPlugin,
    searchPlugin,
    signalsPlugin,
    scaffolderPlugin,
    scaffolderFieldsModule,
    releasesPlugin,
    platformControlPlugin,
    organizationSettingsPlugin,
    navModule,
    homeModule,
    spatialwalkThemeModule,
    signInModule,
  ],
});
